import { FeatureFlagState } from "./reducer";
import { createAction } from "typesafe-actions";
export const SET_FLAGS = "@featureFlags/SET_FLAGS";

export const setFeatureFlags = createAction(
  SET_FLAGS,
  (flags: FeatureFlagState) => ({ flags })
)();
